// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"313":"core-components-deferred","511":"core-components","870":"vendors-editor","985":"vendors-extra"}[chunkId] || chunkId) + "." + {"277":"f318a767","313":"06b2b642","511":"adf3551c","870":"8e061d0e","985":"a1564539"}[chunkId] + ".chunk.js";
};